/**
 * Legacy colour map — kept for backwards compatibility.
 *
 * Every key below now resolves to a value from the new Lobbero palette
 * (see theme.ts / design_system.md). Components that still import `colors`
 * therefore pick up the new "Deep Iris" identity automatically. New code
 * should import from `theme.ts` (`palette`, `gradient`, …) instead.
 */
import { palette } from './theme';

export const colors = {
  purple_light: palette.porcelain, // was #F8F8FE  → Porcelain surface
  purple_dark: palette.iris, // was #946ED1  → brand teal (primary action)
  purple_label: palette.iris, // was #8C67C9  → brand teal (labels/borders)
  white: palette.white,
  black: palette.ink, // was #000     → Midnight Slate ink
  grey: palette.slate, // was #637083  → muted slate
  grey_light: palette.lineStrong, // was #C7CED1  → soft neutral (borders + placeholders)
  grey_dark: palette.ink, // was #333     → ink
  secondary: palette.slate, // was #637083
  primary: palette.iris, // was #26D9D9  → Lagoon Teal (brand realigned to lobbero_web)
  primary_dark: palette.irisDark, // was #02c4c4  → Lagoon
  error: palette.alert, // was #E23E3E  → Coral
  active: palette.irisTintSoft, // was #FBFCFF  → soft teal wash
  dashboard_light_grey: palette.porcelain, // was #f9fafa → Porcelain
};
